import {
  IPaypalOrderData,
  IPaypalOrderResponse
} from '@/interfaces/paypal_order'

import apiClient from '@/utils/request'

export const captureOrder = async (
  payload: IPaypalOrderData
): Promise<IPaypalOrderResponse> => {
  const response = await apiClient.post<IPaypalOrderResponse>(
    '/paypal_orders/capture',
    payload
  )
  return response.data
}
